import { render, staticRenderFns } from "./RestaurantContent.vue?vue&type=template&id=335a0018&scoped=true&"
import script from "./RestaurantContent.vue?vue&type=script&lang=js&"
export * from "./RestaurantContent.vue?vue&type=script&lang=js&"
import style0 from "./RestaurantContent.vue?vue&type=style&index=0&id=335a0018&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "335a0018",
  null
  
)

export default component.exports